export default {
    name: 'Manual',
    data() {
        return {
            Keyword: '',
        };
    },
    mounted() {
        window.model = this;
        this.load();
    },
    methods: {
        load() {
            this.search();
        },
        async search() {
            var result = await this.$api.getManual();

            var container = window.$('#container');
            container.empty();

            var list = [];

            result.forEach((m, i) => {
                var lst = m.Data.filter(v => v.Name.indexOf(this.Keyword) >= 0);
                if (lst.length > 0) {
                    container.append(`<h4 class="block-title color-yellow mg-bottom-16">${m.Title}</h4><div class="mg-bottom-16" id="manualTable_${i}"/>`);
                    m.Data = lst;
                    list.push(m);
                }
            });

            setTimeout(() => {
                result.forEach((m, i) => {
                    var key = '#manualTable_' + i;
                    var cols = [
                        {
                            title: "品名",
                            data: "Name"
                        },
                        {
                            title: "規格",
                            data: "Spec"
                        },
                        {
                            title: "建議備庫數量",
                            data: "SuggestCount"
                        },
                        {
                            title: "單位",
                            data: "Unit"
                        },
                        {
                            title: "建議更換年限",
                            data: "Years"
                        },
                        {
                            title: "備註",
                            data: "Comment"
                        }
                    ];
                    this.createDataTable(key, cols, m.Data, {
                        bSort: false, searching: false, paging: false, bInfo: false
                    });
                });
            });
        }
    }
}